// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Nmq65Z1n-2LwqmKAKHDfb","buttonDiv":"_31LDJxp10Ko6Mp425bdz5I","row":"_2Wh2iiS4NzH_OpHiWrhseW","col":"_1wbuP5LMvfqgEpKAfpx_yp","grey":"_1INBKPJZG1B-VxHDaRUYRP","blue":"SwS_IWIDHhfXx37L3BOF8"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/GetInvolved/styles.scss
 ** module id = 484
 ** module chunks = 0
 **/